export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/homeTestDrive.506404be.svg","height":22,"width":20,"blurWidth":0,"blurHeight":0};